import React from 'react';
import cn from 'classnames';

import LanguageSelectorWrapper from '@app/common/LanguageSelectorWrapper';

import styles from './styles.module.scss';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { IApplicationState } from '@app/store/types/commonTypes';
import { Instance, Languages } from '@app/const/consts';
import { IProps } from './types';
import { Spinner } from '@infologistics/frontend-libraries';
import { getDfLogoSrc } from '@app/utils/utils';

export const FormWrapper = ({
  children,
  forgot,
  copyright,
  nepVerifyPage,
  nepVerifyPageShowNotification,
  nepVerifyPending,
  horizontalView,
}: IProps) => {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const instance = useSelector((state: IApplicationState) => state.utils.instance);

  const instanceRu = instance === Instance.RUSSIAN;
  const languagePt = language === Languages.PT;

  const defaultLogoSrc = getDfLogoSrc();

  return (
    <div className={cn('full-width relative', styles.container)}>
      <div className='d-flex justify-content-between align-items-center'>
        <img src={defaultLogoSrc} alt='docuforce' className={styles.logo}></img>
        <LanguageSelectorWrapper isThemeMini />
      </div>
      {!nepVerifyPage && (
        <h1 className={cn(styles.title_page, 'mb-0 fw-400')}>{forgot ? t('auth:restorePassword') : t('auth:authorization')}</h1>
      )}

      <div className='relative'>{children}</div>
      {instanceRu && !nepVerifyPage && (
        <div className={cn(styles.bottomDiv, 'text-muted', horizontalView && styles.bottomDiv_horizontalView)}>
          <div className={cn(styles.bottomDiv__rules, !horizontalView && 'mb-2', horizontalView && styles.bottomDiv__rules_horizontalView)}>
            {t('auth:rules1')}
            <a
              href='/assets/docs/Правила_платформы_DocuForce.pdf'
              className={cn(styles.bottomDiv__link, 'text-muted')}
              target='_blank'
              rel='noopener noreferrer'
            >
              {t('auth:rules2')}
            </a>
            .
          </div>

          <div>© {copyright ?? 'InfoLogistics LLC. All rights reserved.'}</div>
        </div>
      )}
      {instanceRu && nepVerifyPage && nepVerifyPageShowNotification && (
        <div
          className={cn('d-flex align-items-center justify-content-center', styles.bottomDiv, styles.bottomDiv__adblock, {
            [styles.bottomDiv__adblock_pt]: languagePt,
          })}
        >
          {t('common:nepVerify.adblock')}
        </div>
      )}
      {nepVerifyPending && (
        <div className={cn('absolute full-width d-flex justify-content-center align-items-center', styles.spinnerDiv)}>
          <div className={styles.spinnerDiv__svg}>
            <Spinner />
          </div>
        </div>
      )}
    </div>
  );
};
